//@flow
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { NoItem, AppHeader } from "imagus-components";
import type { StateType } from "../../../global/types/redux";
import type { DictionaryType } from "../../../global/types/GeneralTypes";
import { fetchGroupLicences } from "../../actions/licenceActions";
import type {
  LicenceCompany,
  ChildrenNodeType,
  LicenceNodeType
} from "../../types/licenceTypes";
import LicenceItemRedux from "../../containers/licences/LicenceItemRedux";
import { buildLicenceItemJson } from "../companies/CompileCompanytoJson";
import LicenceList from "./LicenceList";

type Base = {
  licences: LicenceNodeType[]
};

type ChildLicenceLayout = { isChild?: boolean } & { companyType: string };
type NotChildLicenceLayout = { isChild?: never } & { companyType: never };

type LicencePageLayoutPropsType = Base &
  (ChildLicenceLayout | NotChildLicenceLayout);

export const LicencePageLayout = (props: LicencePageLayoutPropsType) => {
  const myLicences = props.licences;

  let myLicenceNode = null;

  if (myLicences) {
    if (myLicences.length === 0) {
      myLicenceNode = (
        <NoItem content="You don't have any Licences in your account" />
      );
    } else if (myLicences.length === 1) {
      myLicenceNode = (
        <LicenceItemRedux
          licence={buildLicenceItemJson(myLicences[0].node)}
          isForUser
          canEdit
        />
      );
    } else {
      let list = myLicences.map((l) => {
        return buildLicenceItemJson(l.node);
      });
      myLicenceNode = <LicenceList licences={list} isForUser canEdit />;
    }
  }

  return (
    <>
      {props.isChild && <AppHeader title={`${props.companyType} Licences`} />}
      {myLicenceNode}
    </>
  );
};
